// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p7-0";
export var buttonContainer = "_p7-3";
export var cancelButton = "_p7-4";
export var headerSection = "_p7-6";
export var headerTitle = "_p7-9";
export var messageSideLeft = "_p7-1";
export var messageSideRight = "_p7-2";
export var orderNumberContainer = "_p7-7";
export var orderNumberLabel = "_p7-8";
export var submitButton = "_p7-5";